
    import './styles.scoped.css';
    export default {
  "placeholder": "awsui_placeholder_dwuol_u9met_9",
  "disabled": "awsui_disabled_dwuol_u9met_14",
  "item": "awsui_item_dwuol_u9met_18",
  "checkbox": "awsui_checkbox_dwuol_u9met_22",
  "option-group": "awsui_option-group_dwuol_u9met_31",
  "filter": "awsui_filter_dwuol_u9met_35",
  "trigger": "awsui_trigger_dwuol_u9met_40",
  "layout-strut": "awsui_layout-strut_dwuol_u9met_46",
  "list-bottom": "awsui_list-bottom_dwuol_u9met_52",
  "selected-icon": "awsui_selected-icon_dwuol_u9met_56",
  "show-label-tag": "awsui_show-label-tag_dwuol_u9met_61",
  "inline-token-trigger": "awsui_inline-token-trigger_dwuol_u9met_65",
  "inline-token-list": "awsui_inline-token-list_dwuol_u9met_72",
  "inline-token-hidden-placeholder": "awsui_inline-token-hidden-placeholder_dwuol_u9met_86",
  "inline-token-counter": "awsui_inline-token-counter_dwuol_u9met_92",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_dwuol_u9met_96",
  "inline-label-wrapper": "awsui_inline-label-wrapper_dwuol_u9met_100",
  "inline-label": "awsui_inline-label_dwuol_u9met_96",
  "inline-label-disabled": "awsui_inline-label-disabled_dwuol_u9met_125",
  "inline-label-inline-tokens": "awsui_inline-label-inline-tokens_dwuol_u9met_129",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_dwuol_u9met_134"
};
  